module.exports = __webpack_public_path__ + "static/dev-58c0e3991dfdbf81032705c4f1381981.svg";